import { ColDef } from 'ag-grid-community';

export const PricingColumnDef: ColDef[] = [
  {
    // Vendor
    headerName: 'Vendor',
    field: 'vendor',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
    tooltipField: 'vendor',
    cellRenderer: (params: any) => {
      if (params.value && params.data.url) {
        return `<a href="${params.data.url}" target="_blank" style="color: #00a8ff; text-decoration: none; font-weight: 500;">${params.value}</a>`;
      }
      return params.value || '';
    },
  },
  {
    headerName: 'Price',
    field: 'price',
    resizable: true,
    width: 120,
    sortable: true,
    filter: true,
    tooltipField: 'price',
    valueFormatter: params => `$${params.value?.toFixed(2)}`,
    cellClassRules: {
      'lowest-price': params => {
        if (!params.data || params.value == null) return false;
        let allPrices: number[] = [];
        params.api.forEachNode(node => {
          if (node.data && node.data.price != null) {
            allPrices.push(node.data.price);
          }
        });
        const minPrice = Math.min(...allPrices);
        return params.value === minPrice;
      }
    }
  },
  {
    // Shipping
    headerName: 'Shipping',
    field: 'shipping',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
    tooltipField: 'shipping',
  },
  {
    // Available
    headerName: 'Available',
    field: 'is_available',
    resizable: true,
    width: 120,
    filter: 'agTextColumnFilter',
    pinned: 'left',
    tooltipField: 'is_available',
  },
];
